import React, { useEffect } from 'react';
import logo from 'assets/images/logos/evamedia-logo-effect.png';
import Animated from 'components/generals/AnimatedComponent';

export default function Preloader() {
    useEffect(() => {
        const timer = setTimeout(() => {
            window.location.href = 'https://evamedia.mx/inicio/';
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    return (
        <main className="nv__preloader">
            <section className="nv__preloader__container">
                <div className="nv__preloader__logo">
                    <Animated animation={'animate__fadeInDown'}>
                        <img src={logo} alt="logo" className="preAnimLogo" />
                    </Animated>
                </div>
            </section>
            <div className="noise"></div>
        </main>
    );
}
